import WellnessStateCircleMobile from '@/components/molecules/WellnessStateCircle/WellnessStateCircleMobile';
import { MIN_SCREENER_SUBMISSIONS_TO_SHOW_ORG_DATA } from '@/constants';
import { Center, Text, VStack } from '@chakra-ui/react';
import React from 'react';

const EXAMPLE_WELLNESS_DATA = {
  fun: 11,
  physical: 27,
  vocational: 37,
  spiritual: 48,
  purpose: 60,
  social: 81,
  mental: 94,
};

const EXAMPLE_ORG_TOTAL_SCORE = 71;

type Props = {
  atLeastCounter?: number;
};

const OrganizationWholenessRingExample = ({ atLeastCounter = MIN_SCREENER_SUBMISSIONS_TO_SHOW_ORG_DATA }: Props) => {
  const isDefault = atLeastCounter === MIN_SCREENER_SUBMISSIONS_TO_SHOW_ORG_DATA;

  return (
    <VStack maxWidth={'100%'} width={'100%'} overflow={'hidden'}>
      <VStack gap={'10px'}>
        <Text variant={'loraExtraSmallTitle'} color={'text.mediumGray'} maxWidth={'300px'}>
          Organization’s Wholeness Ring
        </Text>
        <Text variant={'urbanistSemiBoldRegular'} color={'text.mediumGray'} width={'340px'} textAlign={'center'}>
          {`To protect your Wholeness data, at least ${isDefault ? '3' : `${atLeastCounter} more`} responses are required before your organization’s Wholeness
          Ring can be displayed.`}
        </Text>
      </VStack>
      <Center opacity={0.5} marginTop={'32px'}>
        <WellnessStateCircleMobile
          domainsData={EXAMPLE_WELLNESS_DATA}
          totalScore={EXAMPLE_ORG_TOTAL_SCORE}
          showPercentageText={false}
        />
      </Center>
    </VStack>
  );
};

export default OrganizationWholenessRingExample;
